import { render, staticRenderFns } from "./answer-board.vue?vue&type=template&id=33785616&scoped=true"
import script from "./answer-board.vue?vue&type=script&lang=js"
export * from "./answer-board.vue?vue&type=script&lang=js"
import style0 from "./answer-board.vue?vue&type=style&index=0&id=33785616&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33785616",
  null
  
)

export default component.exports